module.exports = __webpack_public_path__ + "static/media/nissan-x.73cb54f6.jpg";